import Cookie from 'lib/cookie';
import requestPasswordReset from './queries/request-password-reset';
import changePassword from './queries/change-password';
import requestEmailVerification from './queries/request-email-verification';
import resetPasswordWithKey from './queries/reset-password-with-key';
import validatePasswordResetKey from './queries/validate-password-reset-key';
import impersonateUser from './actions/impersonate-user';
import restoreImpersonator from './actions/restore-impersonator';
import sendVerificationEmail from './actions/send-verification-email';
import userLogin from './actions/login';
import signUser from './actions/sign-user';
import userLogout from './actions/logout';
import isUserAuthenticated from './helpers/is-user-authenticated';
import isUserVerified from './helpers/is-user-verified';
import isUserBeingImpersonated from './helpers/is-user-being-impersonated';
import getUserId from './helpers/get-user-id';
import getUserToken from './helpers/get-user-token';
import getUserExpires from './helpers/get-user-expires';
import getTokenExpires from './helpers/get-token-expires';
import isAuth0User from './helpers/is-auth0-user';

/**
 * Export our API, below needs to be refactored
 */
export {
  requestPasswordReset,
  changePassword,
  requestEmailVerification,
  resetPasswordWithKey,
  validatePasswordResetKey,
  impersonateUser,
  restoreImpersonator,
  sendVerificationEmail,
  userLogin,
  signUser,
  userLogout,
  isUserAuthenticated,
  isUserVerified,
  isUserBeingImpersonated,
  getUserId,
  getUserToken,
  getUserExpires,
  getTokenExpires,
  isAuth0User,
};

/**
 * The auth module is meant to be used both on the client and server. To this
 * end we will accept an init object that provides us with our dependencies
 * versus including them directly.
 *
 * Usage:
 *    import Request    from 'superagent';
 *    import Config     from 'client/config';
 *    import AuthClient from 'acast-www-auth-client';
 *
 *    // call once
 *    AuthClient.init({
 *      host    : Config.get('AUTH_HOST'),
 *      request : Request
 *    });
 *
 *    // it is not ok to use
 *    AuthClient
 *      .login('my@user.com', 'secret-password')
 *      .then(...)
 *      .catch(...);
 */
let host = '';
let agent = null;
let cookie = null;

export default {
  init(rawOptions) {
    let options = {};

    if (typeof rawOptions === 'string') {
      options = { host: rawOptions };
    }

    host = options.host || '';
    agent = options.request || null;
    cookie = options.cookie || Cookie.create();
  },

  login(email, password) {
    return new Promise((resolve, reject) => {
      if (agent === null) {
        // eslint-disable-next-line max-len
        return reject(
          new Error('Missing request agent. Please call init first and pass in a valid superagent')
        );
      }

      if (cookie.isTokenValid) {
        return resolve();
      }

      return agent
        .post(`${host}/v1/login/email`)
        .send({ email, password })
        .end((err, res) => {
          if (err) {
            return reject(err);
          }

          cookie.token = res.body;

          if (cookie.isTokenValid) {
            return resolve({
              user: cookie.userId,
              expires: cookie.expires,
              token: cookie.bearer,
            });
          }

          return reject(new Error('Invalid token received'));
        });
    });
  },

  logout() {
    return new Promise(resolve => {
      cookie.token = {};
      resolve();
    });
  },

  get isLoggedIn() {
    return cookie.isTokenValid;
  },

  get bearer() {
    return cookie.bearer;
  },

  get expires() {
    return cookie.expires;
  },

  get user() {
    return cookie.userId;
  },

  // todo: for compatibility we need to export these as defaults too,
  //       however the auth service needs refactoring when we transition
  //       over to global cookie anyway so just keep these here for now
  requestPasswordReset,
  requestEmailVerification,
  resetPasswordWithKey,
  validatePasswordResetKey,
};
